import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './LimitToButton.custom.scss';


export default function LimitToButton (props) {
  const { disableLimit, limitTo } = props;

  return (
    <Button
      id='limit'
      onClick={() => {
        limitTo()
      }}
      disabled={disableLimit}
      buttonConfig={{
        className: 'result-toolbar-limit-to-button',
        label: 'Limit To',
        type: 'link',
        size: 'tiny',
        e2eName: 'limit',
      }}
      iconConfig={{
        position: 'before',
        name: 'screenshot',
        size: 'sm',
      }}
    />
  );
}

LimitToButton.defaultProps = {
  limitTo: () => {
    Logger.error('limitTo something went wrong, value from ng is not a function');
  },
};

LimitToButton.propTypes = {
  limitTo: PropTypes.func,
  disableLimit: PropTypes.bool,
};
